import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { EXPANDS } from '../../enums/expands.enum';
import { OdataResponse } from '../../interfaces/online-only.interface';
import {
    ODataWorkScheduleEntryModel,
    ODataWorkScheduleModel,
    WorkScheduleEntry,
} from '../../models/low-level/work-schedule-set.model';
import { isDefined } from '../../utilities/is-defined';
import { ODataUtilities } from '../../utilities/odata-utilities';
import { UriUtilitiesService } from '../uri-utilities/uri-utilities.service';
import { UserMasterService } from '../user-master/user-master.service';
import { OdataWorkScheduleServiceInterface } from './odata-work-schedule.interface';

@Injectable({
    providedIn: 'root',
})
export class OdataWorkScheduleService implements OdataWorkScheduleServiceInterface {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly uriUtilities: UriUtilitiesService,
        private readonly http: HttpClient,
        private readonly userMasterService: UserMasterService,
    ) {}

    public getWorkScheduleEntries(): Observable<WorkScheduleEntry[]> {
        let query = this.userMasterService.setSalesOrgAndPlantForUrl(
            this.uriUtilities.getUriForContent() + ENDPOINTS.WorkScheduleSet,
        );
        query = this.uriUtilities.appendParameter(query, EXPANDS.WorkSchedule);

        return this.http.get<OdataResponse<ODataWorkScheduleModel>>(query).pipe(
            map((response) => {
                const transformedArray = ODataUtilities.transformResponseDataToArray(response.d);
                if (transformedArray.length === 0) {
                    return {
                        results: [],
                    };
                }
                return transformedArray[0].ScheduleSet;
            }),
            map((response) => {
                return ODataUtilities.transformResponseDataToArray(response)
                    .map((workScheduleEntries: ODataWorkScheduleEntryModel) =>
                        WorkScheduleEntry.fromODataWorkScheduleEntryModel(workScheduleEntries),
                    )
                    .filter(isDefined);
            }),
            catchError((err) => {
                this.log.error(
                    `OdataWorkScheduleService: getWorkScheduleEntries: error ${JSON.stringify(
                        err,
                        Object.getOwnPropertyNames(err),
                    )}`,
                );
                return throwError(err);
            }),
        );
    }
}
